import React, { type ReactNode } from 'react';
import { cssMap, styled } from '@compiled/react';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { MenuListProps } from '@atlaskit/react-select';
import { useIntl } from '@atlassian/jira-intl';
import type { GroupOption } from '../../../common/types.tsx';
import messages from '../../../messages.tsx';

export type Props = {
	options: GroupOption[];
	children: ReactNode;
};

const menuListStyles = cssMap({
	root: {
		paddingBlockStart: token('space.0'),
		paddingBlockEnd: token('space.0'),
	},
});

const MenuListComponent = (props: Props & MenuListProps): React.JSX.Element => {
	const { options } = props;
	const { formatMessage } = useIntl();

	const footer =
		options.length > 0 && options[0].moreResultsAvailable ? (
			<MenuFooterText>{formatMessage(messages.menuFooter)}</MenuFooterText>
		) : null;
	return (
		<components.MenuList {...props} xcss={menuListStyles.root}>
			<Container>{formatMessage(messages.menuHeader)}</Container>
			{props.children}
			{footer}
		</components.MenuList>
	);
};

export default MenuListComponent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MenuFooterText = styled.div({
	color: token('color.text.subtlest'),
	font: token('font.body'),
	paddingTop: token('space.100'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	paddingTop: token('space.100'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.200'),
});
